import React, { Fragment } from "react";
import CreateCategoryForm from "../../Components/Forms/CreateCategoryForm";
import { useNavigate } from "react-router-dom";
import styles from "../MainPages.module.css";
const AddCategory = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <section className={`${styles["cd-cardSection-category"]} ${styles["cd-bgGlass"]}`}>
        <div className={styles["cd-cardHeader"]} >
          <div>
            <button
              type="button"
              className={styles["cd-backBtn-category"]}
              onClick={() => navigate(-1)}
            >
              ← Go Back
            </button>
          </div>
        </div>
      </section>
      <CreateCategoryForm />;
    </Fragment>
  );

};

export default AddCategory;
